// @file 数据导出插入mixin
const currentTypeStore = {};

export const dataExportMixin = {
  data() {
    return {
      // 异步导出任务名汇总
      liveBroadcastStatisticsRecordExportTaskName: 'liveBroadcastStatisticsRecord',
      allocatableResourcesRecordExportTaskName: 'allocatableResourcesRecord',
      subAccountListExportTaskName: 'subAccountList'
    };
  },

  methods: {
    // 获取数据导出中心任务列表
    async getExportList(pageNumber = 1, pageSize = 10) {
      const res = await this.$store.dispatch('dataExport/getExportList', {
        pageNumber,
        pageSize
      });
      this.$store.commit('dataExport/setAllExportedData', res.contents);
    },
    /**
     * 处理异步导出任务
     * @param {*} type 异步导出任务名
     * @param {*} fn 调用对应导出接口的函数
     */
    async asyncDownload(type, fn) {
      if (currentTypeStore[type]) {
        this.$toast.warning('操作太过频繁，请稍后再试');
        return;
      }
      // 重置 isNeedPoll
      this.$store.commit('dataExport/setIsNeedPoll', false);

      currentTypeStore[type] = true;
      try {
        await fn();
        this.$store.commit('dataExport/setDataExportCenterVisible', true);
        setTimeout(() => {
          this.getExportList();
          this.$store.commit('dataExport/setIsNeedPoll', true);
        }, 500);
        setTimeout(function() {
          currentTypeStore[type] = false;
        }, 60 * 1000);
      } catch (error) {
        currentTypeStore[type] = false;
      }
    }
  }
};

export default dataExportMixin;
